import { ContactPage } from '@mui/icons-material';

const NewApplicant = (): JSX.Element => <ContactPage fontSize="inherit" />;

export default NewApplicant;
